import { z } from "zod";
import { ValueSchema } from "../schema/UpdateAvailabilityRestrictionSchema";

const DataSchema = z.array(ValueSchema);

const UpdateAvailabilityRestrictionSchema = z.object({
    data: DataSchema,
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
});

export { UpdateAvailabilityRestrictionSchema, DataSchema };
export type UpdateAvailabilityRestrictionResponse = z.infer<typeof UpdateAvailabilityRestrictionSchema>;
export type DataResponse = z.infer<typeof DataSchema>;